<template>
  <div>
    <main>
      <section class="account_wraper">
        <div class="container_large">
          <div class="login_holder">
            <button class="button" @click="logInWithFacebook">
              Login with Facebook
            </button>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "facebookLogin",
  methods: {
    async logInWithFacebook() {
      await this.loadFacebookSDK(document, "script", "facebook-jssdk");
      await this.initFacebook();
      window.FB.login(function (response) {
        console.log(response);
        if (response.authResponse) {
          // this.SocialLogin(response.authResponse);

          axios
            .post(
              `${process.env.API_URL}/sociallogin/facebook`,
              response.authResponse
            )
            .then((response) => {
              console.log(response.data);
            })
            .catch((err) => {
              console.log({ err: err });
            });

          alert("You are logged in &amp; cookie set!");
          // Now you can redirect the user or do an AJAX request to
          // a PHP script that grabs the signed request from the cookie.
        } else {
          alert("User cancelled login or did not fully authorize.");
        }
      });
      return false;
    },
    async initFacebook() {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: "252029299705223", //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          version: "v13.0",
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },

    SocialLogin(response) {
      axios
        .post(`${process.env.API_URL}/sociallogin/facebook`, response)
        .then((response) => {
          console.log(response.data);
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },
  },
};
</script>
<style>
.button {
  color: white;
  min-width: 150px;
  background-color: #000000a1;
  height: 2.5rem;
  border-radius: 2rem;
  font-weight: 400;
  font-size: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/facebook.vue